<!-- <div class="flex justify-content-end flex-wrap card-container">
  <button type="button" class="btn btn-box-tool" data-widget="collapse">
    <i class="fa fa-minus"></i>
  </button>
</div>  -->
<!-- Update 31/03/22 -->
<div class="grid table-demo">
  <div class="col-12">
    <div class="card mt-2">
      <h5>{{ title }}</h5>
      <div id="p-chart" echarts [options]="optionsCharts()" [merge]="updateOptions()">
        <!-- <dx-chart
          id="chart"
          title="{{ 'Totales por Ubicación' | translate }}"
          [dataSource]="totalsSummary"
          [redrawOnResize]="true"
        >
          <dxo-zoom-and-pan argumentAxis="both"></dxo-zoom-and-pan>
          <dxi-series
            valueField="total_present"
            name="{{ 'Presentes' | translate }}"
          ></dxi-series>
          <dxi-series
            *ngIf="modules.customerType !== CTYPES.ASSETS_NORFID"
            valueField="total_in_transfer"
            name="{{ 'En Transito' | translate }}"
          ></dxi-series>
          <dxi-series
            *ngIf="modules.customerType !== CTYPES.ASSETS_NORFID"
            valueField="total_dispatch"
            name="{{ 'Despachados' | translate }}"
          ></dxi-series>
          <dxi-series
            *ngIf="modules.customerType !== CTYPES.ASSETS_NORFID"
            valueField="total_lost"
            name="{{ 'Perdidos' | translate }}"
          ></dxi-series>
          <dxi-value-axis position="right">
            <dxo-title text="{{ 'Productos' | translate }}"></dxo-title>
          </dxi-value-axis>
          <dxo-common-series-settings
            argumentField="current_location_name"
            type="stackedBar"
          >
          </dxo-common-series-settings>
          <dxo-legend
            verticalAlignment="bottom"
            horizontalAlignment="center"
            itemTextPosition="top"
          >
          </dxo-legend>
          <dxo-export [enabled]="true"></dxo-export>
          <dxo-tooltip
            [enabled]="true"
            location="edge"
            [customizeTooltip]="customizeTooltip"
          >
          </dxo-tooltip>
        </dx-chart> -->
      </div>
    </div>
  </div>
</div>
